import script from "./GartenKultur-Website-Content.vue?vue&type=script&setup=true&lang=js"
export * from "./GartenKultur-Website-Content.vue?vue&type=script&setup=true&lang=js"

import "./GartenKultur-Website-Content.vue?vue&type=style&index=0&id=71f3d50c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f3d50c"]])

export default __exports__